import Headroom from "headroom.js";
const header = document.querySelector(".main-header");

export function headroom() {
	const options = {
		// css classes to apply
		classes: {
			// when element is initialised
			initial: "main-header",
			// when scrolling up
			pinned: "main-header--pinned",
			// when scrolling down
			unpinned: "main-header--unpinned",
			// when above offset
			top: "main-header--top",
			// when below offset
			notTop: "main-header--not-top",
			// when at bottom of scroll area
			bottom: "main-header--bottom",
			// when not at bottom of scroll area
			notBottom: "main-header--not-bottom",
			// when frozen method has been called
			frozen: "main-header--frozen",
			// multiple classes are also supported with a space-separated list
			pinned: "main-header--pinned",
		},
	};
	// pass options as the second argument to the constructor
	// supplied options are merged with defaults
	var headroom = new Headroom(header, options);

	headroom.init();
}
